/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getGdnInvoiceDetailsAsync } from './DataActionExtension.g';
import { IGetGdnInvoiceDetailsResponse } from './DataServiceEntities.g';
import { buildCacheKey } from '@msdyn365-commerce-modules/retail-actions';

/**
 * GetGdnInvoiceDetails Input Action
 */
export class GetGdnInvoiceDetailsInput implements Msdyn365.IActionInput {
    public apiSettings: Msdyn365.ICommerceApiSettings;
    public invoiceNumber: string;
    constructor(apiSettings: Msdyn365.ICommerceApiSettings, invoiceNumber: string) {
        this.apiSettings = apiSettings;
        this.invoiceNumber = invoiceNumber;
    }

    public getCacheKey = () => {
        const baseCacheKey = 'GdnInvoiceDetails';
        if (this.invoiceNumber) {
            return buildCacheKey(`${baseCacheKey}-${this.invoiceNumber}`, this.apiSettings);
        } else {
            return buildCacheKey(`${baseCacheKey}`, this.apiSettings);
        }
    };
    public getCacheObjectType = () => 'GdnInvoiceDetails';
    public dataCacheType = (): Msdyn365.CacheType => 'request';
}

// export interface IGetGdnInvoiceDetailsData {
//     invoiceDetails: IGetGdnInvoiceDetailsResponse;
// }

const createGdnInvoiceDetailsInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    const apiSettings = args.requestContext.apiSettings;
    const invoiceNumber = args.requestContext.query?.invoiceId;
    if (!invoiceNumber) {
        throw new Error('Unable to get invoice details as no valid invoice id found.');
    }
    return new GetGdnInvoiceDetailsInput(apiSettings, invoiceNumber);
};

async function action(input: GetGdnInvoiceDetailsInput, ctx: Msdyn365.IActionContext): Promise<IGetGdnInvoiceDetailsResponse> {
    const response = await getGdnInvoiceDetailsAsync({ callerContext: ctx }, input.invoiceNumber);
    // const response = await getGdnInvoiceDetailsAsync({ callerContext: ctx }, input.invoiceNumber);
    // return { invoiceDetails: response };
    return response;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetGdnInvoiceDetailsResponse>>action,
    id: 'GetGdnInvoiceDetails',
    input: createGdnInvoiceDetailsInput
});
